<!-- <div class="ion-page full-screen-height ion-hide-lg-down" >
  <ion-grid class="full-width-height ion-no-padding" fixed>
    <ion-row class="full-width-height">
      <ion-col class="full-width-height" size="6">
        <ion-content class="ion-padding">

          <div class="ion-margin-vertical" *ngIf="greetingMsg">
            <ion-text class="font-20">{{ greetingMsg }}</ion-text>
          </div>
          <div class="full-width ion-margin-vertical">
            <div class="ion-margin-vertical">
              <ion-text>{{ 'ACCOUNTS.lbl.current_promo' | translate }}</ion-text>
            </div>
            <app-news-card-slide class="full-width" [newsCardSlideType]="'promotion'" [setReady]="ready"></app-news-card-slide>
          </div>

          <div class="full-width ion-margin-vertical">
            <app-news-card-slide class="full-width" [newsCardSlideType]="'accounts_list'" [setReady]="ready"></app-news-card-slide>
          </div>
        </ion-content>
      </ion-col>
      <ion-col class="full-width-height" size="6">
        <ion-toolbar class="" color="secondary" *ngIf="showSearch">
          <app-search [type]="'accountList'" [reset]="resetSearch" [disableFilter]="true" (action)="search($event)"></app-search>
        </ion-toolbar>
        <ion-toolbar class="seg-toolbar" *ngIf="showSearch">
          <ng-container *ngIf="true then segmentBlock"></ng-container>
        </ion-toolbar>
        
        <ion-content>
          <ng-container *ngIf="true then contentBlock"></ng-container>
        </ion-content>
      </ion-col>
    </ion-row>
  </ion-grid>
</div> -->
<!-- ion-hide-lg-up -->
<div class="ion-page">
  <ion-header #header>
    <ion-toolbar class="ion-no-padding" color="secondary">
      <ion-buttons slot="start">
        <ion-menu-button>
          <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
          <app-inbox-count></app-inbox-count>
        </ion-menu-button>
      </ion-buttons>
      <ion-title>
        <app-offline-indicator></app-offline-indicator>
        {{ 'ACCOUNT.lbl.list' | translate }}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button class="ion-margin" expand="block" (click)="toggleSearch()">
          <ion-icon color="black" name="search" *ngIf="!showSearch"></ion-icon>
          <ion-icon color="black" name="close" *ngIf="showSearch"></ion-icon>
        </ion-button>
      </ion-buttons>
      <!-- <ion-item class="user-item" color="secondary" lines="none">
        <ion-buttons slot="start">
          <ion-menu-button>
            <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
            <app-inbox-count></app-inbox-count>
          </ion-menu-button>
        </ion-buttons>
        <ion-title>
          <app-offline-indicator></app-offline-indicator>
          {{ 'ACCOUNT.lbl.list' | translate }}
        </ion-title>
        <ion-buttons slot="end">
          <ion-button class="ion-margin" expand="block" (click)="presentAccountsAddModal()">
            <ion-icon color="dark" slot="icon-only" name="add"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-label *ngIf="user?.name">
          <div class="text-ellipsis" (click)="goProfile()">
            <ion-text class="font-semi">{{ user.name }}</ion-text>
          </div>
        </ion-label>
        <ion-avatar class="small-avatar" slot="end" (click)="goProfile()">
          <ng-container *ngIf="user?.avatar?.url">
            <ion-img [src]="user.avatar.url" *ngIf="user.avatar?.type === 'local'"></ion-img>
            <app-cached-image [src]="user.avatar.url" [spinner]="true" *ngIf="user?.avatar?.type !== 'local'"></app-cached-image>
          </ng-container>
          <ion-icon color="medium" src="./assets/wedding/img/avatar/blank.svg" *ngIf="!user?.avatar?.url"></ion-icon>        
        </ion-avatar>
        <ion-button fill="clear" id="popover-button" slot="end">
          <ion-icon name="ellipsis-horizontal-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-popover trigger="popover-button" dismiss-on-select="true">
          <ng-template>
            <ion-content>
              <ion-list>
                <span *ngFor="let menu of menuList">
                  <ion-item class="background-transparent"  *ngIf="menu?.url && !menu?.disable" (click)="goPage(menu.url)" lines="none">
                    <div>
                      <ng-container *ngIf="menu?.icon?.name">
                        <ion-icon class="menu-icon" [name]="menu.icon.name" ></ion-icon>
                      </ng-container>
                      <ng-container *ngIf="menu?.icon?.src">
                        <ion-icon class="menu-icon" [src]="menu.icon.src" ></ion-icon>
                      </ng-container>
                      <ng-container *ngIf="menu?.icon?.off && menu?.icon?.on">
                        <ion-icon class="menu-icon" [src]="menu.icon.on"></ion-icon>
                        <ng-template #offIcon>
                          <ion-icon class="menu-icon" [src]="menu.icon.off" ></ion-icon>
                        </ng-template>
                      </ng-container>
                      <ion-text >{{ 'MENU.' + menu.title | translate }}</ion-text>
                      <ng-container *ngIf="menu?.title === 'inbox'">
                        <app-inbox-count class="badge" [badgeColor]="'danger'" [showBadge]="true" [showNumber]="true"></app-inbox-count>
                      </ng-container>
                    </div>
                  </ion-item>
                </span>
                
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
      </ion-item> -->
    </ion-toolbar>
    <ion-toolbar color="secondary">
      <app-news-card-slide class="full-width" [newsCardSlideType]="'accounts_list'" [setReady]="ready"></app-news-card-slide>
    </ion-toolbar>
    <ion-toolbar class="" color="secondary" *ngIf="showSearch">
      <div class="content-div">
        <app-search [type]="'accountList'" [reset]="resetSearch" [disableFilter]="true" (action)="search($event)"></app-search>
      </div>
    </ion-toolbar>
    <ion-toolbar class="seg-toolbar" *ngIf="showSearch">
      <ng-container *ngIf="true then segmentBlock"></ng-container>
    </ion-toolbar>
  </ion-header>
  
  <ion-content class="ion-padding-horizontal" color="light" #content>
    <ng-container *ngIf="true then contentBlock"></ng-container>
  </ion-content>
  <!-- <ion-toolbar>
    <ion-tab-bar>
      <ion-tab-button href="#/accounts/list">
        <ion-icon name="home" aria-hidden="true"></ion-icon>
        <ion-label>{{ 'MENU.home' | translate }} </ion-label>
      </ion-tab-button>
  
      <ion-tab-button (click)="presentAccountsAddModal()">
        <ion-icon name="add" aria-hidden="true"></ion-icon>
        <ion-label>{{ 'CRUD.add' | translate }}</ion-label>
      </ion-tab-button>
  
      <ion-tab-button  href="#/inbox/home">
        <ion-icon name="chatbubble-ellipses" aria-hidden="true"></ion-icon>
        <ion-label>{{ 'MENU.inbox' | translate }}</ion-label>
      </ion-tab-button>
  
      <ion-tab-button (click)="toggleSearch()">
        <ion-icon name="search" aria-hidden="true"></ion-icon>
        <ion-label>{{ 'BTN.search' | translate }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-toolbar> -->
</div>

<!-- <ion-header class="header-light" #header>
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'ACCOUNT.lbl.list' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-margin" expand="block" (click)="goPremiumPage()">
        <ion-icon color="dark" slot="icon-only" name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right ion-no-padding">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'accounts_list'" [setReady]="ready"></app-news-card-slide>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right">
    <app-search [type]="'accountList'" [reset]="resetSearch" [disableFilter]="true" (action)="search($event)"></app-search>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right">
    <ion-segment scrollable [(ngModel)]="accountsListType" (ionChange)="segmentChanged()">
      <ion-segment-button value="all">
        <ion-label>{{ 'LBL.all' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="upcoming">
        <ion-label>{{ 'ACCOUNTS.lbl.upcoming' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="passed">
        <ion-label>{{ 'ACCOUNTS.lbl.passed' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-horizontal" color="light" #content>
  <div class="no-record-div full-width center vertical-center" *ngIf="!userAccountsList?.length">
    <div>
      <ion-label class="ion-text-center ion-margin" color="medium" *ngIf="accountExisted || searchTerm">
        <ion-icon class="center icon-cactus" color="medium" src="./assets/wedding/icon/general/no-record.svg"></ion-icon>
        <div class="ion-margin-top font-12"><ion-text color="medium">{{ 'LBL.no_found' | translate }}</ion-text></div>
      </ion-label>
      <div class="intro-div ion-padding ion-margin-vertical" *ngIf="!accountExisted">
        <ion-img class="img center ion-margin-top" src="./assets/wedding/img/blast/result/result.webp"></ion-img>
        <div class="ion-margin-vertical ion-padding-vertical">
          <div class="ion-margin-vertical ion-text-center">
            <ion-text class="font-14">{{ 'ACCOUNTS.trial.msg.experience_title' | translate }} </ion-text>
          </div>
          <div class="ion-margin-vertical ion-text-center">
            <ion-text class="font-10">{{ 'ACCOUNTS.trial.msg.experience_intro' | translate }} </ion-text>
          </div>
          <ion-button class="ion-margin" expand="block" (click)="goTrialPage()">
            {{ 'ACCOUNTS.trial.lbl.start_trial' | translate }}
          </ion-button>
        </div>
        <div class="line ion-margin"></div>
        <div class="ion-margin-vertical">
          <div class="ion-margin-vertical ion-text-center" (click)="goPremiumPage()">
            <ion-text class="font-14 font-med font-underline">{{ 'ACCOUNTS.msg.join_account' | translate }} </ion-text>
          </div>
          <div class="ion-margin-vertical ion-text-center" (click)="goPremiumPage()">
            <ion-text class="font-10">{{ 'ACCOUNTS.msg.join_account_msg' | translate }} </ion-text>
          </div>
        </div>
      </div>
    </div>
  </div>  
  
  <div class="full-width-height viewport-div" *ngIf="userAccountsList?.length">
    <cdk-virtual-scroll-viewport [itemSize]="150" *ngIf="userAccountsList?.length">
      <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list>
        <ion-card class="account-card" *cdkVirtualFor="let account of userAccountsList; trackBy: trackByFn; let i = index;" button>
          <ion-item-sliding #slidingItem>
            <ion-item class="account-item item ion-item-no-padding background-transparent" (click)="loginAccount(account)" lines="none">
              <ion-card class="ion-text-center ion-no-margin countdown-card" [color]="countDown < 0 ? 'grey' : 'tertiary'" slot="start" *ngIf="countDownList?.[account?.accountId] as countDown">
                <ion-text color="dark" *ngIf="countDown > 0">
                  <div><ion-text class="font-bold font-18">{{ countDown }}</ion-text></div>
                  <div>
                    <ion-text class="font-10 ion-text-uppercase">
                      <ng-container *ngIf="countDown > 1 else elseBlock">
                        {{ 'LBL.days' | translate }}
                      </ng-container>
                      <ng-template #elseBlock>
                        {{ 'LBL.day' | translate }}
                      </ng-template>
                    </ion-text>
                  </div>
                </ion-text>
                <ion-text class="font-bold font-10 ion-text-uppercase" color="dark" *ngIf="countDown < 0">
                  {{ 'LBL.completed' | translate }}
                </ion-text>
                <ion-text class="font-bold font-10 ion-text-uppercase" color="dark" *ngIf="countDown === '0'">
                  {{ 'LBL.today' | translate }}
                </ion-text>
              </ion-card>
              <div class="line-120 padding-right text-ellipsis">
                <ion-label class="account-title font-16 font-bold line-200 text-ellipsis" color="dark">
                  <ng-container *ngIf="account?.title?.value">
                    {{ account.title.value }}
                  </ng-container>
                  <ng-container *ngIf="!account?.title?.value">
                    <ng-container *ngIf="account?.coupleNameList?.length === 2 && account?.coupleNameList[0]?.name && account?.coupleNameList[1]?.name else titleBlock">
                      {{ 'ACCOUNT.auto_title' | translate: { couple1: account.coupleNameList[0].name, couple2: account.coupleNameList[1].name } }}
                    </ng-container>
                    <ng-template #titleBlock>
                      {{ 'ACCOUNT.lbl.wedding_title' | translate }}
                    </ng-template>
                  </ng-container>
                </ion-label>
                <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.time?.seconds && account?.timezone?.utc">
                  <ion-icon class="icon-small accounts-list-icon" slot="start" name="calendar-outline"></ion-icon>
                  {{ format(account.time.seconds * 1000, 'do MMM yyyy, EEEE', account.timezone.name ) }}
                </ion-label>
                <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.time?.seconds && account?.timezone?.utc">
                  <ion-icon class="icon-small accounts-list-icon" name="time-outline"></ion-icon>
                  {{ format(account.time.seconds * 1000, 'h:mm a', account.timezone.name ) }} &nbsp;<span class="font-10">({{ account.timezone.utc }})</span>
                </ion-label>
                <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.role?.type">
                  <ion-icon class="icon-small accounts-list-icon" name="person-outline"></ion-icon>
                  <ng-container *ngIf="account?.role?.custom">{{ account.role.type }}</ng-container>
                  <ng-container *ngIf="!account?.role?.custom">{{ 'LIST.role.' + account.role.type | translate }}</ng-container>
                  <ng-container *ngIf="account?.owner">&nbsp;({{ 'LIST.role.owner' | translate }})</ng-container>
                </ion-label>
                <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.accountStatus">
                  <app-account-status [accountStatus]="account?.accountStatus" [setupTrialData]="account?.trialData"></app-account-status>
                </ion-label>
              </div>
            </ion-item>
            <ion-item-options side="end" (ionSwipe)="checkActionSwipe(account)">
              <ion-item-option color="danger" (click)="deleteAccount(account.accountId)" *ngIf="account?.accountId && !account?.owner && !account?.role?.coupleId"><ion-icon name="trash-outline"></ion-icon></ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        </ion-card>
      </ion-list>
    </cdk-virtual-scroll-viewport>
  </div>
</ion-content> -->

<ng-template #newsCardBlock>
  <app-news-card-slide class="full-width" [newsCardSlideType]="'accounts_list'" [setReady]="ready"></app-news-card-slide>
</ng-template>

<ng-template #segmentBlock>
  <div class="content-div">
    <ion-segment [(ngModel)]="accountsListType" (ionChange)="segmentChanged()" scrollable>
      <ion-segment-button value="all">
        <ion-label>{{ 'LBL.all' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="upcoming">
        <ion-label>{{ 'ACCOUNTS.lbl.upcoming' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="passed">
        <ion-label>{{ 'ACCOUNTS.lbl.passed' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>
</ng-template>

<ng-template #contentBlock>
  <div class="content-div">
    <div class="no-record-div full-width center vertical-center" *ngIf="!userAccountsList?.length">
      <div>
        <ion-label class="ion-text-center ion-margin" color="medium" *ngIf="accountExisted || searchTerm">
          <ion-icon class="center icon-cactus" color="medium" src="./assets/wedding/icon/general/no-record.svg"></ion-icon>
          <div class="ion-margin-top font-12"><ion-text color="medium">{{ 'LBL.no_found' | translate }}</ion-text></div>
        </ion-label>
        <div class="intro-div ion-padding ion-margin-vertical" *ngIf="!accountExisted">
          <ion-img class="img center ion-margin-top" src="./assets/wedding/img/blast/result/result.webp"></ion-img>
          <div class="ion-margin-vertical ion-padding-vertical">
            <div class="ion-margin-vertical ion-text-center">
              <ion-text class="font-14">{{ 'ACCOUNTS.trial.msg.experience_title' | translate }} </ion-text>
            </div>
            <div class="ion-margin-vertical ion-text-center">
              <ion-text class="font-10">{{ 'ACCOUNTS.trial.msg.experience_intro' | translate }} </ion-text>
            </div>
            <ion-button class="ion-margin" expand="block" (click)="goTrialPage()">
              {{ 'ACCOUNTS.trial.lbl.start_trial' | translate }}
            </ion-button>
          </div>
          <div class="line ion-margin"></div>
          <div class="ion-margin-vertical">
            <div class="ion-margin-vertical ion-text-center" (click)="goPremiumPage()">
              <ion-text class="font-14 font-med font-underline">{{ 'ACCOUNTS.msg.join_account' | translate }} </ion-text>
            </div>
            <div class="ion-margin-vertical ion-text-center" (click)="goPremiumPage()">
              <ion-text class="font-10">{{ 'ACCOUNTS.msg.join_account_msg' | translate }} </ion-text>
            </div>
          </div>
        </div>
      </div>
    </div>  
    
    <div class="full-width-height viewport-div" *ngIf="userAccountsList?.length">
      <cdk-virtual-scroll-viewport [itemSize]="130" *ngIf="userAccountsList?.length">
        <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list>
          <ion-card class="account-card" *cdkVirtualFor="let account of userAccountsList; trackBy: trackByFn; let i = index;" button>
            <ion-item-sliding class="account-item" #slidingItem>
              <ion-item class="item ion-item-no-padding background-transparent" (click)="loginAccount(account)" lines="none">
                <ion-card class="ion-text-center ion-no-margin countdown-card" [color]="countDown < 0 ? 'grey' : 'tertiary'" slot="start" *ngIf="countDownList?.[account?.accountId] as countDown">
                  <ion-text color="dark" *ngIf="countDown > 0">
                    <div><ion-text class="font-bold font-18">{{ countDown }}</ion-text></div>
                    <div>
                      <ion-text class="font-10 ion-text-uppercase">
                        <ng-container *ngIf="countDown > 1 else elseBlock">
                          {{ 'LBL.days' | translate }}
                        </ng-container>
                        <ng-template #elseBlock>
                          {{ 'LBL.day' | translate }}
                        </ng-template>
                      </ion-text>
                    </div>
                  </ion-text>
                  <ion-text class="font-bold font-10 ion-text-uppercase" color="dark" *ngIf="countDown < 0">
                    {{ 'LBL.completed' | translate }}
                  </ion-text>
                  <ion-text class="font-bold font-10 ion-text-uppercase" color="dark" *ngIf="countDown === '0'">
                    {{ 'LBL.today' | translate }}
                  </ion-text>
                </ion-card>
                <div class="line-100 full-width padding-right text-ellipsis">
                  <ion-label class="account-title font-16 font-bold line-200 text-ellipsis" color="dark">
                    <ng-container *ngIf="account?.title?.value">
                      {{ account.title.value }}
                    </ng-container>
                    <ng-container *ngIf="!account?.title?.value">
                      <ng-container *ngIf="account?.coupleNameList?.length === 2 && account?.coupleNameList[0]?.name && account?.coupleNameList[1]?.name else titleBlock">
                        {{ 'ACCOUNT.auto_title' | translate: { couple1: account.coupleNameList[0].name, couple2: account.coupleNameList[1].name } }}
                      </ng-container>
                      <ng-template #titleBlock>
                        {{ 'ACCOUNT.lbl.wedding_title' | translate }}
                      </ng-template>
                    </ng-container>
                  </ion-label>
                  <!-- <ion-grid class="full-width font-12 text-ellipsis ion-no-padding" fixed>
                    <ion-row class="ion-align-items-center ion-justify-content-center" *ngIf="account?.time?.seconds && account?.timezone?.utc">
                      <ion-col sizeXs="2" sizeSm="1"><ion-icon class="icon-small accounts-list-icon" name="calendar-outline"></ion-icon></ion-col>
                      <ion-col>{{ format(account.time.seconds * 1000, 'do MMM yyyy, EEEE', account.timezone.name ) }}</ion-col>
                    </ion-row>
                    <ion-row class="ion-align-items-center ion-justify-content-center" *ngIf="account?.time?.seconds && account?.timezone?.utc">
                      <ion-col sizeXs="2" sizeSm="1"><ion-icon class="icon-small accounts-list-icon" name="time-outline"></ion-icon></ion-col>
                      <ion-col>{{ format(account.time.seconds * 1000, 'h:mm a', account.timezone.name ) }} &nbsp;<span class="font-10">({{ account.timezone.utc }})</span></ion-col>
                    </ion-row>
                    <ion-row class="ion-align-items-center ion-justify-content-center" *ngIf="account?.role?.type">
                      <ion-col sizeXs="2" sizeSm="1"><ion-icon class="icon-small accounts-list-icon" name="person-outline"></ion-icon></ion-col>
                      <ion-col>
                        <ng-container *ngIf="account?.role?.custom">{{ account.role.type }}</ng-container>
                        <ng-container *ngIf="!account?.role?.custom">{{ 'LIST.role.' + account.role.type | translate }}</ng-container>
                        <ng-container *ngIf="account?.owner">&nbsp;({{ 'LIST.role.owner' | translate }})</ng-container>
                      </ion-col>
                    </ion-row>
                  </ion-grid> -->
                  <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.time?.seconds && account?.timezone?.utc">
                    <ion-icon class="icon-small accounts-list-icon" name="calendar-outline"></ion-icon>
                    <ion-text class="vertical-middle">{{ format(account.time.seconds * 1000, 'date', account.timezone.name ) }}</ion-text>
                  </ion-label>
                  <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.time?.seconds && account?.timezone?.utc">
                    <ion-icon class="icon-small accounts-list-icon" name="time-outline"></ion-icon>
                    <ion-text class="vertical-middle">{{ format(account.time.seconds * 1000, 'time', account.timezone.name ) }} &nbsp;<span class="font-10">({{ account.timezone.utc }})</span></ion-text>
                  </ion-label>
                  <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.role?.type">
                    <ion-icon class="icon-small accounts-list-icon" name="person-outline"></ion-icon>
                    <ion-text class="vertical-middle">
                      <ng-container *ngIf="account?.role?.custom">{{ account.role.type }}</ng-container>
                      <ng-container *ngIf="!account?.role?.custom">{{ 'LIST.role.' + account.role.type | translate }}</ng-container>
                      <ng-container *ngIf="account?.owner">&nbsp;({{ 'LIST.role.owner' | translate }})</ng-container>
                    </ion-text>
                  </ion-label>
                  <ion-label class="font-12 text-ellipsis" color="dark" *ngIf="account?.accountStatus">
                    <app-account-status [accountStatus]="account?.accountStatus" [setupTrialData]="account?.trialData"></app-account-status>
                  </ion-label>
                </div>
              </ion-item>
              <ion-item-options side="end" (ionSwipe)="checkActionSwipe(account)">
                <ion-item-option color="danger" (click)="deleteAccount(account.accountId)" *ngIf="account?.accountId && !account?.owner && !account?.role?.coupleId"><ion-icon name="trash-outline"></ion-icon></ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-card>
        </ion-list>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</ng-template>